// 直播
<template>
  <div class="liveBroadcastContainer">
    <div class="lbLLHeader">
      <div class="lbLLHTitle">
        <div class="lbLLHTBtn">
          <el-button icon="el-icon-refresh-right" circle @click="initLiveList()"></el-button>
        </div>
        <div class="lbLLHTText">
          讲座列表
        </div>
        <div class="lbLLHTBtn">
          <el-button icon="el-icon-bell" circle @click="clickReservingBtn()"></el-button>
        </div>
      </div>
    </div>
    <div class="lbLLMain">
      <div class="lbLLMList" v-if="liveListData[0]">
        <div class="lbLLMLItem" v-for="(item, index) in liveListData" :key="index" @click="ifGoLiveDetail(item, index)">
          <div class="lbLLMLITitle">
            <div class="lbLLMLITIcon" :class="{'btnPlay': item.onPush, 'btnPause': !item.onPush}">
              <i class="el-icon-video-play" v-if="item.onPush"></i>
              <i class="el-icon-video-pause" v-if="!item.onPush"></i>
            </div>
            <div class="lbLLMLITText">
              {{ item.publishTitle }}
            </div>
          </div>
          <div class="lbLLMLIMain">
            <img :src="item.publishCover">
          </div>
        </div>
      </div>
      <div class="lbLLMList" v-else>
        <div class="lbLLMLItem">
          <div class="lbLLMLITitle">
            <div class="lbLLMLITIcon btnPause">
              <i class="el-icon-video-pause"></i>
            </div>
            <div class="lbLLMLITText">
              欢迎来到环保学园
            </div>
          </div>
          <div class="lbLLMLIMain">
            <img src="../assets/liveIcon/noLiveCover.jpg">
          </div>
        </div>
      </div>
    </div>
    <div class="lbLLHeader">
      <div class="lbLLHTitle">
        <div class="link-content-1">
          <span v-if="userName">
            <span class="login" @click="doLogin">{{userName}}</span>
          </span>
          <span v-else>
            <span class="login" @click="doLogin" style="padding:0 10px 0 0">登录/注册</span>
          </span>
          <span @click="$router.push('/h5download')" style="padding:0 0 0 20px">下载</span>
        </div>
      </div>
    </div>
    <accountCom :showLogin.sync="loginDialogShow" @dispatchUserName="receiveName"></accountCom>
  </div>
</template>

<script>
import api from '../../api/index'
import accountCom from '@/components/account/index'
export default {
  data () {
    return {
      liveDatas: [{
        id: 0,
        liveAdmin: false,
        liveRight: false,
        muted: false,
        onLive: false,
        onPush: false,
        phone: '',
        publishCover: '',
        publishTitle: ''
      }],
      userPh: '',
      userLiveAdmin: false,
      userLiveRight: false,
      liveListData: {},
      liveItemData: {},
      userInfoData: {},
      userLiveData: {},
      // showLivePlayerF: true,
      showDownloadOBSF: false,
      reservingText: '',
      isReserved: false,
      showReservingF: false,
      loginDialogShow: false,
      userName: sessionStorage.getItem('qs_user_name')
    }
  },
  mounted () {
    this.initLiveList()
    console.log('333333')
    // this.getLivePicture()
  },
  computed: {
  },
  methods: {
    initLiveList () {
      this.liveListData = {}
      this.liveItemData = {}
      this.userInfoData = {}
      this.userLiveData = {}
      // this.goLiveDetail(this.liveItemData)
      this.getUserData()
    },
    getUserData () {
      api.getUserInfo().then(resUI => {
        this.userInfoData = resUI.data
        this.userPh = resUI.data.phone
        console.log('userInfoData', this.userInfoData)
        api.spLiveEnquiry({
          phone: this.userPh
        }).then(resUL => {
          this.userLiveData = resUL.data.list[0]
          this.userLiveAdmin = this.userLiveData.liveAdmin
          this.userLiveRight = this.userLiveData.liveRight
          console.log('userLiveData', this.userLiveData)
          this.getLiveListData()
        })
      })
    },
    getLiveListData () {
      var enquiryPusher = {
        pages: 99,
        pageNo: 1,
        liveRight: true
      }
      if (!this.userLiveAdmin && !this.userLiveRight) { enquiryPusher.onLive = true }
      api.spLiveEnquiry(enquiryPusher).then(resLL => {
        this.liveListData = resLL.data.list
        console.log('liveListData', this.liveListData)
      })
    },
    ifGoLiveDetail (item, index) {
      console.log('goLiveDetails')
      var roomId = item.id
      api.spLiveByEnquiry({
        roomId: roomId
      }).then(resUl => {
        console.log('resUl', resUl)
        var isUnlocked = resUl.data.unlocked
        var isUnlMsg = resUl.message
        if (isUnlocked || this.userLiveAdmin || JSON.stringify(item) === '{}') {
          this.goLiveDetail(item)
        } else {
          console.log('goUnlLiveDetails')
          var unlConfirm = confirm(isUnlMsg)
          if (unlConfirm) {
            api.spLiveByUpdate({
              roomId: roomId
            }).then(resDoUl => {
              if (resDoUl.data.unlocked) {
                var sucMsg = alert('解锁成功')
                if (sucMsg) {
                  this.goLiveDetail(item)
                }
              } else {
                var errMsg = alert(resDoUl.message)
                if (errMsg) {}
              }
            })
          }
        }
      })
    },
    goLiveDetail (item) {
      this.liveItemData = item
      console.log('liveItem', this.liveItemData, this.userInfoData, this.userLiveData)
      location.assign(`/h5live-detail?liveItemData=${JSON.stringify(item)}&userInfoData=${JSON.stringify(this.userInfoData)}&userLiveData=${JSON.stringify(this.userLiveData)}`)
    },
    clickReservingBtn () {
      api.spLiveReservationEnquiry().then(res => {
        console.log(res.data)
        this.reservingText = res.data.text
        this.isReserved = res.data.isReserved
        if (res.data.isReserved) {
          var cntRsvCon = alert(`${res.data.text}（已预约）`)
          if (cntRsvCon) {}
        } else {
          var canRsvCon = confirm(res.data.text)
          if (canRsvCon) {
            this.doReserveLive()
          }
        }
      })
    },
    doReserveLive () {
      console.log('doReserve')
      api.spLiveReservationUpdate().then(res => {
        var isRsvd = alert(res.message)
        if (isRsvd) {}
      })
    },
    doLogin () {
      this.loginDialogShow = true
    },
    receiveName (val) {
      this.userName = val
      this.$emit('dispatchUserName', val)
      this.getUserData()
    },
    destroy () {
      console.log('destroy')
      this.showLivePlayerF = false
      var that = this
      that.$destroy()
    }
  },
  components: {
    accountCom
  }
}
</script>

<style lang="scss">
.liveBroadcastContainer{
  width: 100%!important;
  height: 100%!important;
  background-color: #fff;
  font-family: 'Times New Roman', 'SimHei', Georgia, Times, serif;
  background-color: #f9f9f9;
  .lbLLHeader{
    width: 100%;
    height: 40px!important;
    // padding: 10px;
    .lbLLHTitle{
      width: calc(100% - 10px);
      height: 30px!important;
      padding: 4px;
      text-align: center;
      font-size: 20px;
      display: flex;
      border: #ddd solid 1px;
      background-color: #eee;
      .lbLLHTText{
        width: calc(100% - 64px);
        height: 30px;
        line-height: 30px;
        margin: 0 4px;
        font-weight: bolder;
      }
      .lbLLHTBtn{
        width: 30px;
        height: 30px;
        line-height: 100%;
        // margin: 4px;
        .el-button{
          width: 30px;
          height: 30px;
          margin: 0!important;
          padding: 7px!important;
          background-color: #f9f9f9;
        }
      }
      .link-content-1{
        width: 100%;
        height: 30px;
        text-align: center;
        line-height: 30px;
        margin: 0 4px;
      }
    }
  }
  .lbLLMain{
    // width: calc(100% - 10px)!important;
    height: calc(100% - 80px)!important;
    width: 100%;
    // height: 100%;
    .lbLLMList{
      width: 100%;
      // height: calc(100% - 80px)!important;
      height: 100%;
      overflow: auto;
      .lbLLMLItem{
        width: calc(100% - 10px)!important;
        // margin: 0 0 4px;
        padding: 4px;
        border: #ddd solid 1px;
        // border-radius: 16px;
        background-color: #eee;
        overflow: hidden;
        .lbLLMLITitle{
          // height: 32px;
          display: flex;
          font-size: 16px;
          margin-bottom: 4px;
          .lbLLMLITIcon{
            width: 24px;
            height: 24px;
            text-align: center;
            line-height: 24px;
            color: #fff;
            border-radius: 100%;
            i{
              font-size: 24px;
            }
          }
          .btnPause{
            background-color: #666;
          }
          .btnPlay{
            background-color: #409eff;
          }
          .lbLLMLITText{
            width: calc(100% - 32px);
            margin: 0 2px;
            padding-right: 8px;
            line-height: 24px;
            font-size: 16px;
          }
        }
        .lbLLMLIMain{
          line-height: 0;
          border: #ddd solid 1px;
          border-radius: 12px;
          overflow: hidden;
          img{
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
          }
        }
      }
    }
  }
}
</style>
